module.exports = __webpack_public_path__ + "img/tervezhetoseg_kep_768.c4cc0991.png";